module.exports = __webpack_public_path__ + "img/196.e7a06920.jpg";